import styled, { keyframes } from 'styled-components';
import { TransparentButton } from '../transparent-button/TransparentButton';
import Typography from '../typography/Typography';
const fadeInAnim = keyframes `
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;
const appearFromBelowAnim = keyframes `
  from {
    transform: translateY(100%);
  } to {
    transform: translateY(0%);
  }
`;
export const ModalTitle = styled(Typography) `
  margin-left: ${({ hasIcon }) => (hasIcon ? '0.8rem' : '0')};
`;
export const Layer = styled.div `
  display: flex;
  align-items: flex-end;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${({ theme }) => theme.colors.surface.popup};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};

  animation: ${fadeInAnim} ${({ modalAnimationTime }) => modalAnimationTime}s
    linear;
  transition: opacity ${({ modalAnimationTime }) => modalAnimationTime}s ease;

  z-index: ${({ theme }) => theme.zIndex.highest};

  ${({ theme }) => theme.media.laptop `
    align-items: center;
  `}
`;
export const ModalContent = styled.section `
  width: 100%;
  overflow: hidden;
  border-radius: 2rem 2rem 0 0;
  background-color: ${({ theme }) => theme.colors.surface.default};
  animation: ${appearFromBelowAnim}
    ${({ modalAnimationTime }) => modalAnimationTime}s linear;
  transform: ${({ isOpen }) => isOpen ? 'translateY(0%)' : 'translateY(100%)'};
  transition: transform ${({ modalAnimationTime }) => modalAnimationTime}s ease;

  ${({ theme, leftSpace }) => {
    const leftPosition = (leftSpace
        ? leftSpace / 2
        : 0);
    return theme.media.laptop `
      position: relative;
      left: ${leftPosition}rem;
      width: unset;
      height: unset;
      border-radius: 1.2rem 1.2rem 1.2rem 1.2rem;
  `;
}}
`;
export const TitleWrapper = styled.div `
  padding: 0 6rem;
  text-align: center;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;

  position: relative;

  height: 5.8rem;

  border-bottom: ${({ shouldHideHeaderBorder, theme }) => shouldHideHeaderBorder
    ? 'none'
    : `1px solid ${theme.colors.borders.default}`};

  background-color: ${({ headerBackground, theme }) => headerBackground
    ? headerBackground
    : theme.colors.surface.interactiveDefault};

  svg {
    width: 3rem;
    height: 3rem;
  }
`;
export const IconButton = styled(TransparentButton) `
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0;
  margin-right: 0.6rem;
`;
export const DescWrapper = styled.div `
  max-width: 35rem;
  margin-top: 0.8rem;
`;
export const TitleButton = styled(TransparentButton) `
  position: absolute;
  right: 2.2rem;
`;
export const ChildrenWrapper = styled.div `
  max-height: calc(100vh - 2rem);

  overflow-y: auto;
  overflow-x: hidden;

  ${({ theme }) => theme.media.tablet `
    max-height: 86vh;
  `}
`;
export const IconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.2rem;
  height: 3.2rem;
  background-color: ${({ theme, shouldHideHeaderBorder }) => shouldHideHeaderBorder ? theme.colors.surface.tertiary : 'transparent'};
  border: ${({ theme, shouldHideHeaderBorder }) => `1px solid ${shouldHideHeaderBorder ? 'transparent' : theme.colors.borders.default}`};
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  cursor: pointer;

  svg {
    height: initial;
    width: initial;
  }
`;
//# sourceMappingURL=styles.js.map